export default __webpack_public_path__ + "static/left-side-border-9deccb8ba08874299bb208c61605b0ef.png";